export const RATINGS_DATA_UPLOAD = 'RATINGS_DATA_UPLOAD'
export const RATINGS_DATA_UPLOAD_RESPONSE = 'RATINGS_DATA_UPLOAD_RESPONSE'

export const uploadRatingsData = (data) => {
    return {
        type: RATINGS_DATA_UPLOAD,
        data
    }
}

export const uploadRatingsDataResponse = (data) => {
    return {
        type : RATINGS_DATA_UPLOAD_RESPONSE,
        data
    }
}